import React, {FunctionComponent, useContext} from "react";
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import {OptionContext} from "../../context/OptionContext";
import {useCardFeeRecoveryContext} from "../../context/CardFeeRecoveryContext";

export const InvoicePaymentAmountRows: FunctionComponent = () => {
    const invoice: Invoice = useContext(InvoiceContext);
    const optionContext = useContext(OptionContext);
    const cardFeeRecovery = useCardFeeRecoveryContext();
    const isShowCardFeeRecoverySummary = cardFeeRecovery.isEnabled && !optionContext.isFallbackToPricesWithoutCardFeeRecovery;

    if (!(invoice.is_amount_due_visible && invoice.is_payment_available)) {
        return null;
    }

    return isShowCardFeeRecoverySummary
        ? <>
            <div className="summary-item total-summary-item">
                <p>Amount Due (Card): </p>
                <p>{optionContext.getPaymentAmountFormatted()}</p>
            </div>
            <div className="summary-item total-summary-item">
                <p>Amount Due ({invoice.is_ach_payment_available ? 'ACH' : 'Cash'}): </p>
                <p>{optionContext.getPaymentAmountWithoutCardFeeRecoveryFormatted()}</p>
            </div>
        </>
        : <div className="summary-item total-summary-item">
            <p>Amount Due: </p>
            <p>{optionContext.getPaymentAmountFormatted()}</p>
        </div>;
};
